import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check-circle-big",
  "use": "check-circle-big-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"check-circle-big\">\n  <path fill-rule=\"evenodd\" d=\"M309,277a16,16,0,1,1,16-16A16,16,0,0,1,309,277Zm0-29a13,13,0,1,0,13,13A13.015,13.015,0,0,0,309,248Zm-0.439,18.56a1.5,1.5,0,0,1-2.121,0l-5-5a1.5,1.5,0,0,1,2.121-2.121l3.939,3.94,6.94-6.94a1.5,1.5,0,0,1,2.121,2.121Z\" transform=\"translate(-293 -245)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/check-circle-big.svg
// module id = null
// module chunks = 